import { Component, Host, h, Prop, State } from '@stencil/core';
import { illustrationMapping, type IllustrationMapping } from './illustrations';

@Component({
  tag: 'anchor-product-illustration',
  styleUrl: 'product-illustration.scss',
  shadow: true,
  assetsDirs: ['illustrations'],
})
export class ProductIllustration {
  /**
   *  Give this instance of product-illustration custom ID.
   */
  @Prop() uuid: string;

  /**
   *  This the type of illustration that you want to use
   */
  @Prop({ reflect: true }) name: IllustrationMapping;

  /**
   *  Set the size that you want the illustration to be
   */
  @Prop() size: 'small' | 'medium' | 'large' | 'xlarge' = 'medium';

  @State() svg: string;

  componentWillLoad() {
    this.loadIllustration();
  }

  async loadIllustration() {
    const illustrationImport = illustrationMapping[this.name];
    if (illustrationImport) {
      const module = await illustrationImport();
      this.svg = module.default;
    }
  }
  
  render() {
    return (
      <Host>
        <div class={`anchor-c-product-illustration ${this.size}`} innerHTML={this.svg}></div>
      </Host>
    );
  }
}
